import { ca } from '@cian/analytics';

/* istanbul ignore next */
export function trackCall(analyticParams: { label: string; products: Object; page: Object; user: Object }) {
  ca('eventSite', {
    category: 'Phones',
    action: 'Call',
    ...analyticParams,
  });
}
